import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { ProdutividadeOperador } from '../../types/pessoas';
import { apontamentosProducaoService, operadoresService, produtividadeOperadorService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<ProdutividadeOperador>[] = [
  {
    name: 'operador',
    label: 'Operador',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      operadoresService.list,
      (item: any) => item.nome ?? String(item.id),
    ),
    required: true,
  },
  {
    name: 'apontamento',
    label: 'Apontamento',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      apontamentosProducaoService.list,
      (item: any) => item.apontamento_info ?? item.id,
    ),
    required: true,
  },
  { name: 'horas_trabalhadas', label: 'Horas trabalhadas', type: 'number' },
  { name: 'quantidade_produzida', label: 'Quantidade produzida', type: 'number' },
  { name: 'quantidade_refugada', label: 'Quantidade refugada', type: 'number' },
  { name: 'data_referencia', label: 'Data de referência', type: 'date' },
];

export const ProdutividadeOperadorFormPage: React.FC = () => (
  <ResourceFormPage
    title="Produtividade do operador"
    description="Associe desempenho individual por apontamento."
    fields={fields}
    service={produtividadeOperadorService}
    redirectPath="/admin/pessoas/produtividade-operador"
    cancelPath="/admin/pessoas/produtividade-operador"
  />
);
